import { Component, OnInit } from '@angular/core';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CustomStatusService } from './service/custom-status.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { statusInterface } from 'src/app/util/interfaces/statusInterface';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

export interface customStatusInterface {
	id: number;
	status: string;
	label: string;
	notAllowed: boolean;
}

@Component({
	selector: 'register-form-custom-status',
	templateUrl: './custom-status.component.html',
	styleUrls: ['./custom-status.component.scss'],
})
export class CustomStatusComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_geral_criado_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_geral_nome: '',
		lbl_geral_nome_customizado: '',
		lbl_geral_sim: '',
		lbl_geral_nao: '',
		lbl_geral_desativado: '',
		lbl_geral_atualizar: '',
		lbl_geral_buscar: '',
		lbl_geral_status: '',
		lbl_personalizacao_status: '',
		lbl_geral_voltar: '',
	};

	searchHeader: mspTableHeaderI[] = [{ name: 'label', value: 'lbl_geral_status', colType: 'text' }];

	constructor(
		private LabelsService: LabelsService,
		private CustomStatusService: CustomStatusService,
		private NotificationService: NotificationService
	) {}

	isLoadingLabels = true;
	isLoadingAllStatus = true;
	isUpdatingStatus = false;

	allStatus: statusInterface[] = [];
	allStatusIAC: iacOptionInterface[] = [];

	selectedStatus: statusInterface = {
		id: -1,
		label: '',
		status: '',
		notAllowed: false,
	};

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.CustomStatusService.getAllStatus().subscribe((status) => {
			this.allStatus = status;
			this.allStatusIAC = [];
			for (const status of this.allStatus) {
				const newIAC: iacOptionInterface = {
					name: status.label,
					value: status.status,
					secondName: status.status,
				};
				this.allStatusIAC.push({ ...newIAC });
			}
			this.isLoadingAllStatus = false;
		});
	}

	selectStatus(selectedStatus: string): void {
		for (let index = 0; index < this.allStatus.length; index++) {
			const status: statusInterface = this.allStatus[index];
			if (status.status == selectedStatus) {
				this.selectedStatus = status;
				break;
			}
		}
		return;
	}

	cleanSelected(): void {
		this.selectedStatus = {
			id: -1,
			label: '',
			status: '',
			notAllowed: false,
		};
	}

	createCustomStatus(): void {
		if (this.isUpdatingStatus) return;
		this.isUpdatingStatus = true;

		this.CustomStatusService.createCustomStatus(this.selectedStatus).subscribe(
			(status) => {
				this.selectedStatus.id = status.id;
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isUpdatingStatus = false;
			},
			() => {
				this.isUpdatingStatus = false;
			}
		);
	}

	updateCustomStatus(): void {
		if (this.isUpdatingStatus) return;
		this.isUpdatingStatus = true;

		this.CustomStatusService.updateCustomStatus(this.selectedStatus).subscribe(
			(status) => {
				this.selectedStatus.id = status.id;
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isUpdatingStatus = false;
			},
			() => {
				this.isUpdatingStatus = false;
			}
		);
	}
}
